import { message } from 'antd';
import { putWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const updateHealthmetricType = async (data: any, refetch?: () => void) => {
  console.log('Updating healthmetrictypes with: ', data);
  try {
    const response = await putWithCSRF(`${envApiUrl}/healthmetrictypes/`, data);
    message.success('Successfully updated Healthmetric Type');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('updateHealthmetricType error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to update Healthmetric Type');
  }
};
